import { isPageSelectedSelector, pageNameSelector } from 'app/Page/selectors';
import connect from 'utils/store/connect';

import PageName from './components/PageName';

/**
 * map redux state to react component properties
 * @param {object} state - redux state object
 * @returns {object} react props
 */
const mapStateToProps = state => ({
  isPageSelected: isPageSelectedSelector(state),
  pageName: pageNameSelector(state)
});

export default connect(mapStateToProps)(PageName);
